<template>

  <div class="navigation__item">

    <div class="icon--languageselector"></div>

    <select class="navigation__item__language" @change="changeLanguage($event)">
      <option v-for="(lang, index) in languages" :selected="lang.value === currentLang" :value="lang.value"
              :key="`lang${index}`">
        {{ lang.title }}
      </option>
    </select>
  </div>

</template>

<script>
import { localize } from 'vee-validate'
import moment from 'moment'

export default {
  name: 'LanguagePicker',
  data () {
    return {}
  },
  computed: {
    languages () {
      return this.$store.getters['language/list']
    },
    currentLang () {
      return this.$store.getters['language/current']
    }
  },
  methods: {
    changeLanguage (event) {
      let lang = event.target.value
      this.$i18n.locale = lang
      localize(lang)
      moment.locale(lang)
      this.$store.dispatch('language/setLanguage', lang)
    }
  }
}
</script>
<style>
  .dropdown {
    float: right;
    overflow: hidden;
  }

  .dropdown .dropbtn {
    font-size: 16px;
    border: none;
    outline: none;
    color: white;
    padding: 14px 16px;
    background-color: inherit;
    font-family: inherit;
    margin: 0;
  }

  .dropdown-content {
    display: none;
    position: absolute;
    background-color: #f9f9f9;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
  }

  .dropdown-content a {
    float: none;
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    text-align: left;
  }

  .dropdown-content a:hover {
    background-color: #ddd;
  }

  .dropdown:hover .dropdown-content {
    display: block;
  }
</style>
